import { useState } from "react";
import { Navigate, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { api, errMsg } from "@/lib/api";
import { useGame } from "@/context/GameContext";
import { Input } from "@/components/ui/input";

const IMG = "/art/battle_bg.webp";

export default function Login() {
  const { user, refresh } = useGame();
  const nav = useNavigate();
  const [mode, setMode] = useState("login");
  const [form, setForm] = useState({ email: "", password: "", name: "" });
  const [busy, setBusy] = useState(false);
  if (user) return <Navigate to="/journey" replace />;

  const google = () => {
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    const redirectUrl = window.location.origin + "/journey";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await api.post(mode === "login" ? "/auth/login" : "/auth/register", form);
      await refresh();
      nav("/journey");
    } catch (err) {
      toast.error(errMsg(err));
    } finally { setBusy(false); }
  };

  const set = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  return (
    <main className="relative min-h-[calc(100vh-4rem)] grid lg:grid-cols-2">
      <div className="relative hidden lg:block overflow-hidden grain">
        <img src={IMG} alt="Moonlit forest clearing" className="absolute inset-0 w-full h-full object-cover" />
        <div className="absolute inset-0 bg-gradient-to-r from-transparent to-[#061016]" />
        <p className="absolute bottom-12 left-12 font-display text-3xl text-amber-50/90 max-w-sm leading-snug">Every wolf starts alone.</p>
      </div>
      <div className="flex items-center justify-center p-6">
        <div className="w-full max-w-sm rise">
          <h1 className="font-display text-4xl text-amber-100 mb-2">{mode === "login" ? "Return to the wild" : "Join the hunt"}</h1>
          <p className="text-slate-400 mb-8 text-sm">Your progress is saved to your account.</p>
          <button data-testid="google-login-btn" onClick={google} className="w-full flex items-center justify-center gap-3 py-3 rounded-lg bg-slate-100 text-slate-900 font-semibold hover:bg-white transition-colors">
            <svg className="w-5 h-5" viewBox="0 0 48 48"><path fill="#FFC107" d="M43.6 20.5H42V20H24v8h11.3C33.7 32.7 29.2 36 24 36c-6.6 0-12-5.4-12-12s5.4-12 12-12c3.1 0 5.8 1.2 7.9 3.1l5.7-5.7C34 6.1 29.3 4 24 4 12.9 4 4 12.9 4 24s8.9 20 20 20 20-8.9 20-20c0-1.3-.1-2.4-.4-3.5z"/><path fill="#FF3D00" d="M6.3 14.7l6.6 4.8C14.7 15.1 19 12 24 12c3.1 0 5.8 1.2 7.9 3.1l5.7-5.7C34 6.1 29.3 4 24 4 16.3 4 9.7 8.3 6.3 14.7z"/><path fill="#4CAF50" d="M24 44c5.2 0 9.9-2 13.4-5.2l-6.2-5.2C29.2 35.1 26.7 36 24 36c-5.2 0-9.6-3.3-11.3-7.9l-6.5 5C9.5 39.6 16.2 44 24 44z"/><path fill="#1976D2" d="M43.6 20.5H42V20H24v8h11.3c-.8 2.2-2.2 4.2-4.1 5.6l6.2 5.2C37 39.2 44 34 44 24c0-1.3-.1-2.4-.4-3.5z"/></svg>
            Continue with Google
          </button>
          <div className="flex items-center gap-3 my-6 text-xs text-slate-500"><span className="flex-1 h-px bg-slate-800" />OR<span className="flex-1 h-px bg-slate-800" /></div>
          <form onSubmit={submit} className="space-y-3">
            {mode === "register" && <Input data-testid="register-name-input" placeholder="Your name" value={form.name} onChange={set("name")} required className="h-11 bg-slate-900/80" />}
            <Input data-testid="auth-email-input" type="email" placeholder="Email" value={form.email} onChange={set("email")} required className="h-11 bg-slate-900/80" />
            <Input data-testid="auth-password-input" type="password" placeholder="Password (6+ characters)" value={form.password} onChange={set("password")} required minLength={6} className="h-11 bg-slate-900/80" />
            <button data-testid="auth-submit-btn" disabled={busy} className="ember-btn w-full py-3 rounded-lg text-sm">{busy ? "…" : mode === "login" ? "SIGN IN" : "CREATE ACCOUNT"}</button>
          </form>
          <button data-testid="auth-toggle-mode" onClick={() => setMode(mode === "login" ? "register" : "login")} className="mt-6 text-sm text-sky-300 hover:text-sky-200">
            {mode === "login" ? "New here? Create an account" : "Already have an account? Sign in"}
          </button>
        </div>
      </div>
    </main>
  );
}
